import { getConfig } from '@superbet-group/web.lib.config';
import { Dispatch } from 'vuex';

import modalCodes from '@store/modules/ui/shared/modal/modalCodes';

export default {
    namespaced: true,
    state: {},

    actions: {
        showError({ dispatch }: { dispatch: Dispatch }, error: Error) {
            if (!getConfig().environment.isProduction) {
                // eslint-disable-next-line no-console
                console.log(error);
            }
            dispatch(
                'ui/modal/setModal',
                modalCodes.error,
                { root: true },
            );

            // TODO just show visual error, something went wrong, try again later
        },
    },
};
